module.exports = __webpack_public_path__ + "img/copy-btn.48ed2833.svg";